export default __webpack_public_path__ + "static/media/sticker.92e6e149.png";